module.exports = __webpack_public_path__ + "static/media/User.f7ea648e.svg";